import { FC, useMemo } from 'react'
import clsx from 'clsx'
import { Theme } from '@/common/pd-meta-components-types'
import PdImage from '@/components/pd-image/pd-image'
import PdMedia from '@/components/pd-media/pd-media'
import WatchVideo from '@/components/pd-watch-video/pd-watch-video'
type Section1Type = {
  mediaUrl: string
  titleUrl: string
  subTitle: string
  videoUrl: string
  theme?: string // dark,light,gray
  maskColor?: string
  maskDegree?: number
}

const Section1: FC<Section1Type> = ({
  theme,
  mediaUrl = '',
  titleUrl,
  subTitle,
  videoUrl,
  maskColor = 'transparent',
  maskDegree = 180,
}) => {
  const maskClassName = useMemo(() => {
    if (titleUrl || subTitle) {
      switch (theme) {
        case Theme.Light:
          return 'bg-gradient-to-b from-white/50'
        case Theme.Dark:
        default:
          return 'bg-gradient-to-b from-black/50'
      }
    }
    return ''
  }, [theme, titleUrl, subTitle])

  return (
    <div className={clsx('w-full h-fit relative', `pd-theme-${theme} bg-container-primary`)}>
      <div className={clsx('w-full', 'h-[177.86vw] laptop:h-[56.25vw] overflow-hidden')}>
        <PdMedia src={mediaUrl} mask={false} />
      </div>
      <div
        className={clsx(
          'absolute top-0 left-0 w-full h-[50%] px-6 pt-15 laptop:pt-28',
          'flex flex-col items-center',
          maskClassName
        )}
        style={{
          background: `linear-gradient(${maskDegree}deg, ${maskColor}, transparent)`,
        }}
      >
        {titleUrl && (
          <div className={clsx('w-full laptop:max-w-300', 'h-8 laptop:h-20', 'mb-3 laptop:mb-4')}>
            <PdImage src={titleUrl} object="contain" width="100%" height="100%" enableMask={false} priority={true} />
          </div>
        )}
        {subTitle && (
          <h1 className={clsx('max-w-200 mx-auto', 'mb-3 laptop:mb-4', 'break-words', 'text-fc-primary pd-main-text')}>
            {subTitle}
          </h1>
        )}
        {videoUrl && (
          <WatchVideo
            className="px-[3.2vw] py-[2.13vw] laptop:px-[0.8333vw] laptop:py-[0.4166vw]"
            textClassName={'text-[3.73vw] laptop:text-[0.73vw]'}
            videoUrl={videoUrl}
          />
        )}
      </div>
    </div>
  )
}

export default Section1
